interface Props {
    className?: string;
}

export function DropdownArrowIcon({ className }: Props) {
    return (
        <svg className={className} viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12.4865 3.5H11.4611C11.3914 3.5 11.3258 3.53418 11.2847 3.59023L7.40056 8.94414L3.51638 3.59023C3.47537 3.53418 3.40974 3.5 3.34002 3.5H2.31463C2.22576 3.5 2.17381 3.60117 2.22576 3.67363L7.04646 10.3195C7.22146 10.5602 7.57967 10.5602 7.7533 10.3195L12.574 3.67363C12.6273 3.60117 12.5754 3.5 12.4865 3.5Z"
                fill="currentColor"
            />
        </svg>
    );
}
